module.exports = __webpack_public_path__ + "img/21_59.f39036dd.png";